/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react/jsx-no-target-blank */
import { loginRememberKey, scope } from '@/config/base';
import { getLocalStorage } from '@/utils/cookies';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Checkbox, Form, Input, message } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useRef, useState } from 'react';
import Captcha from '../Captcha';
import SubmitButton from '../SubmitButton';
import styles from './index.less';

const { useForm } = Form;

type AccountPasswordLoginProps = {
  /** 平台名称 */
  platformName?: string;
  /** 白色背景 */
  white?: boolean;
  /** 用户服务名称 */
  serviceText?: string;
  /** 隐私协议名称 */
  privacyText?: string;
  /** 服务协议 */
  serviceProtocolUrl?: string;
  /** 隐私协议 */
  privacyProtocolUrl?: string;
  /** 是否展示协议 */
  protocolBool?: boolean;
  /** 忘记密码 */
  forgetUrl?: () => void;
  /** 账号密码 - 点击登录 */
  onLogin?: (
    params: {
      account: string;
      pwd: string;
      channel: 'account' | 'phone';
      seq?: number;
      captchaType: 'blockPuzzle' | 'image';
      captcha: string;
      scope: string;
    },
    bol?: boolean,
    error?: any,
  ) => void;
};

/** 账号密码登录 */
const AccountPasswordLogin: React.FC<AccountPasswordLoginProps> = (props) => {
  const {
    white,
    platformName,
    protocolBool,
    onLogin,
    forgetUrl,
    serviceText,
    privacyText,
    serviceProtocolUrl,
    privacyProtocolUrl,
  } = props;

  const [form] = useForm();
  const [canLogin, setCanLogin] = useState(false);
  const [rememberUser, setRememberUser] = useState(false);
  const captchaContainer = useRef<any>();

  // eslint-disable-next-line no-shadow
  const onFinish = (values: any) => {
    setCanLogin(true);
    onLogin &&
      onLogin(
        {
          ...values,
          channel: 'account',
          scope,
          captchaType: 'blockPuzzle',
        },
        rememberUser,
        captchaContainer,
      );
  };

  const validPhoneNo = (rule: any, value: any) => {
    console.log(value);
    if (value === '') {
      return Promise.reject(new Error('登录账号不能为空'));
    }
    // if (!validIsMobile(value)) {
    //   return Promise.reject(new Error('手机号格式不正确'));
    // }
    return Promise.resolve();
  };

  const agreementValid = (rule: any, val: any) => {
    return val ? Promise.resolve() : Promise.reject();
  };

  const getErrorMessage = () => {
    const errors = form.getFieldsError();
    let errorMessage: string[] = [];
    errors.forEach((item) => {
      errorMessage = errorMessage.concat(item.errors);
    });
    const errorMsg = errorMessage.reverse().pop();
    errorMsg && message.error(errorMsg);
  };

  useEffect(() => {
    const userData = getLocalStorage(loginRememberKey);
    if (userData) {
      setRememberUser(true);
      form.setFieldsValue(userData);
    }
  }, []);

  return (
    <Form
      form={form}
      className="container"
      size="large"
      onFinish={onFinish}
      onFinishFailed={getErrorMessage}
    >
      <Form.Item
        name="account"
        noStyle
        rules={[
          {
            required: true,
            validator: validPhoneNo,
          },
        ]}
      >
        <Input
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          autoComplete="off"
          placeholder="输入登录账号"
          type="search"
          prefix={<UserOutlined />}
        />
      </Form.Item>

      <Form.Item name="pwd" noStyle rules={[{ required: true, message: '登录密码不能为空' }]}>
        <Input.Password
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          prefix={<LockOutlined />}
          placeholder="输入登录密码"
          autoComplete="off"
        />
      </Form.Item>
      <Form.Item name="captcha" noStyle rules={[{ required: true, message: '请先校验拼图' }]}>
        <Captcha
          ref={captchaContainer}
          captchaSuccess={(v) => {
            form.setFieldValue('captcha', v);
          }}
          captchaError={() => {
            form.setFieldValue('captcha', '');
          }}
        />
      </Form.Item>
      <Form.Item noStyle valuePropName="checked" wrapperCol={{ span: 24 }}>
        <div style={{ marginBottom: protocolBool ? 10 : 24 }}>
          <Checkbox
            className={`${styles['small-font']} ${protocolBool ? '' : styles['small-margin']} `}
            checked={rememberUser}
            onChange={(e) => setRememberUser(e.target.checked)}
          >
            记住账号密码
          </Checkbox>
          <span
            className={`${styles['small-font']} ${styles.protocol} ${
              protocolBool ? '' : styles['small-margin']
            }`}
            style={{ paddingLeft: 6, cursor: 'pointer' }}
            onClick={forgetUrl}
          >
            忘记密码？
          </span>
        </div>
      </Form.Item>
      {protocolBool ? (
        <Form.Item
          name="protocol"
          valuePropName="checked"
          noStyle
          wrapperCol={{ span: 24 }}
          rules={[
            {
              validator: agreementValid,
              message: '请先阅读勾选服务条款与隐私协议',
            },
          ]}
        >
          <div style={{ marginBottom: 16 }}>
            <Checkbox className={`${styles['small-font']}`}>阅读并同意{platformName}</Checkbox>
            <a
              href={serviceProtocolUrl || ''}
              className={`${styles['small-font']} ${styles.protocol} `}
              target="_blank"
            >
              {serviceText || '服务协议'}
            </a>
            <span className={styles['small-font']}> 和 </span>
            <a
              className={`${styles['small-font']} ${styles.protocol} `}
              href={privacyProtocolUrl || ''}
              target="_blank"
            >
              {privacyText || '隐私协议'}
            </a>
          </div>
        </Form.Item>
      ) : null}

      <Form.Item wrapperCol={{ span: 24 }}>
        {/* <Button
          className={`${styles['custom-btn']} ${!canLogin ? styles.disabled : ''}`}
          type="primary"
          htmlType="submit"
          size="large"
          block
        >
          登录
        </Button> */}
        <SubmitButton
          form={form}
          label="登录"
          buttonProps={{ type: 'primary', size: 'large', block: true }}
        />
      </Form.Item>
    </Form>
  );
};

export default AccountPasswordLogin;
